import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getUser = (token, id) => {
    return fetch(`${apiUrl}users/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getUser